import { EventContext, Fields } from '@vimeo/bigpicture-client';

export const viewBpContextName = 'view_context';
export const viewBpContextSchemaVersion = 6;
export type ViewBpContext = Fields<typeof viewBpContextName, typeof viewBpContextSchemaVersion>;

export const buildViewBpContext = (fields: ViewBpContext) => {
  return {
    view_context: new EventContext(viewBpContextName, viewBpContextSchemaVersion, fields),
  };
};
